import classNames from "classnames";
import { range } from "lodash";
import { forwardRef } from "react";
import { CollapsibleState } from "~/components/build/Show/components/Sidebar/TreeItem/CollapsibleState";
import { TreeNodeType } from "~/components/build/Show/components/Sidebar/TreeNode";

interface TreeItemProps extends React.HTMLAttributes<HTMLDivElement> {
  depth: number;
  totalCount: number;
  type: TreeNodeType;
  collapsibleState: CollapsibleState;
  children: React.ReactNode;
  index: number;
}

/** @deprecated Use `~/components/build/Show/routes/list/-components/TreeItem/TreeItem` instead. */
export const TreeItem = forwardRef<HTMLDivElement, TreeItemProps>((props, ref) => {
  const { collapsibleState, depth } = props;

  const isExpanded =
    collapsibleState === CollapsibleState.Expanded || collapsibleState === CollapsibleState.Full;

  return (
    <div
      aria-posinset={props.index + 1}
      aria-setsize={props.totalCount}
      aria-hidden={props.type === TreeNodeType.Spacer ? true : undefined}
      role="treeitem"
      aria-level={depth < 0 ? 0 : depth}
      aria-expanded={collapsibleState !== CollapsibleState.None ? isExpanded : undefined}
      tabIndex={-1}
      style={props.style}
      className="group relative flex w-full items-baseline bg-white"
      ref={ref}
    >
      {props.children}

      {depth > 0 &&
        range(1, depth + 1).map((depth) => (
          <div
            key={depth}
            className={classNames("absolute bottom-0 top-0 -z-10 border-l border-gray-400", {
              "left-[calc(0.75rem+1px)]": depth === 1,
              "left-8": depth === 2,
            })}
          />
        ))}
    </div>
  );
});
